import { BaseService } from './../../../shared/services/base.service';
import { Component, OnInit, OnChanges, DoCheck } from '@angular/core';
import { CustomObject } from '../raise-risk/raise-risk.component';
import { TranslateService } from '@ngx-translate/core';

declare var d3: any;
@Component({
  selector: 'ara-line-graph',
  templateUrl: './line-graph.component.html',
  styleUrls: ['./line-graph.component.css']
})
export class LineGraphComponent implements OnInit, OnChanges, DoCheck {
  data: CustomObject[];
  pearName: string = '';
  constructor(private baseService: BaseService,
    private translate:TranslateService) {
    this.data = [];
  }

  ngOnInit() {
    this.data = [];
    this.displayCharts();
    this.baseService.translatorListener.subscribe((data)=>
    {
    this.translate.use(data);
    });
  }

  ngOnChanges() {
    this.data = [];
    this.data = this.baseService.getDataForLine();
    this.pearName = this.data[0].pearName;
    this.displayCharts();
  }

  ngDoCheck() {
    this.data = [];
    this.data = this.baseService.getDataForLine();
    if (this.data.length > 0) {
      this.pearName = this.data[0].pearName;
      this.displayCharts();
    }
  }
  displayCharts() {
    d3.select("#chart").selectAll("*").remove();
    let margin = { top: 40, right: 40, bottom: 40, left: 40 },
      width = 450 - margin.left - margin.right,
      height = 350 - margin.top - margin.bottom;

    let x = d3.scale.linear()
      .range([0, width]);

    let y = d3.scale.linear()
      .range([height, 0]);

    let valueline = d3.svg.line()
      .x(function (d) { return x(d.value); })
      .y(function (d) { return y(d.module); });

    let svg = d3.select("#chart")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // Coerce the strings to numbers.
    this.data.forEach(function (d) {
      d.value = +d.value;
      d.module = +d.module;
    });

    // Compute the scales� domains.
    x.domain([0, 6]);
    y.domain([6, 0]);

    // Add the x-axis.
    svg.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0,0)")
      .call(d3.svg.axis().scale(x).orient("top").ticks(5));

    //xaxis title 
    svg.append("text")
      .attr("x", width / 2)
      .attr("y", -25)
      .style("text-anchor", "middle")
      .text("Likelihood");

    // Add the y-axis.
    svg.append("g")
      .attr("class", "y axis")
      .call(d3.svg.axis().scale(y).orient("left").ticks(5));

    //yaxis title
    svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 0 - margin.left)
      .attr("x", 0 - (height / 2))
      .attr("dy", "1em")
      .style("text-anchor", "middle")
      .text("Severity");

    // Add the points!
    svg.selectAll(".point")
      .data(this.data)
      .enter().append("path")
      .attr("class", "point")
      .attr("d", function (d, i) {
        switch (i) {
          case 0:
            return d3.svg.symbol().type(d3.svg.symbolTypes[0])();
          case 1:
            return d3.svg.symbol().type(d3.svg.symbolTypes[5])();
          case 2:
            return d3.svg.symbol().type(d3.svg.symbolTypes[3])();
        }
      })
      .attr("transform", function (d) { return "translate(" + x(d.value) + "," + y(d.module) + ")"; });

    svg.append("path")
      .attr("class", "line")
      .attr("d", valueline(this.data));
  }
  displayChart() {
    const svg = d3.select('#chart'),
      margin = { top: 20, right: 20, bottom: 30, left: 40 },
      width = +svg.attr('width') - margin.left - margin.right,
      height = +svg.attr('height') - margin.top - margin.bottom;

    const x = d3.scaleLinear().range([0, width - (margin.left + margin.right)]);
    const y = d3.scaleLinear().range([height - (margin.top * 2), 0]);

    const line = d3.line()
      .x(function (d) { return x(d.module); })
      .y(function (d) { return y(d.value); });

    const g = svg.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    this.data.forEach(function (d) {
      d.value = +d.value;
      d.module = +d.module;
    });

    x.domain(d3.extent(this.data, function (d) { return d.module; }));
    y.domain([
      (Math.floor(d3.min(this.data, function (d) { return d.value; }) / 10) * 10),
      (Math.ceil(d3.max(this.data, function (d) { return d.value; }) / 10) * 10)
    ]);

    // add the Y gridlines
    g.append('g')
      .attr('class', 'grid')
      .call(d3.axisLeft(y)
        .tickSize(-width)
        .tickFormat('')
        .ticks(6)
      );

    g.append('g')
      .attr('class', 'axis axis--x')
      .attr('transform', 'translate(' + ((margin.left + margin.right) / 2) + ',' + (height - margin.top) + ')')
      .call(d3.axisBottom(x)
        .ticks(4)
        .tickFormat(function (d) { return 'Cat' + d; })
      )
      .selectAll('.axis--x .tick text')
      .append('tspan')
      .attr('class', 'axis-tspan')
      .attr('x', 0)
      .attr('y', 0)
      .attr('dy', margin.top * 2);

    g.append('g')
      .attr('class', 'axis axis--y')
      .call(d3.axisLeft(y).ticks(6))
      .append('text')
      .attr('class', 'axis-title')
      .attr('transform', 'rotate(-90)')
      .attr('y', 6)
      .attr('dy', '.71em');

    const clinicalCutOffLineAndText = g.append('g')
      .attr('class', 'clinical-cut-off-line-and-text')

    // Clinicial cut off line
    clinicalCutOffLineAndText.append('line')
      .attr('class', 'clinical-cut-off-line')
      .attr('x1', 0)
      .attr('x2', width)

    // Clinicial cut off text
    clinicalCutOffLineAndText.append('text')
      .attr('class', 'clinical-cut-off-text')
      .attr('dy', '20px')

    const lineAndDots = g.append('g')
      .attr('class', 'line-and-dots')
      .attr('transform', 'translate(' + ((margin.left + margin.right) / 2) + ',' + 0 + ')')

    // Data line
    lineAndDots.append('path')
      .datum(this.data)
      .attr('class', 'this.data-line')
      .attr('d', line);

    // Data dots
    lineAndDots.selectAll('line-circle')
      .data(this.data)
      .enter().append('circle')
      .attr('class', 'this.data-circle')
      .attr('r', 5)
      .attr('cx', function (d) { return x(d.module); })
      .attr('cy', function (d) { return y(d.value); });
  }
}
